import { JSXMap } from 'fennec-ui';
import React from 'react';

export default function LevelBreadcrumbs(props) {
    const { elements } = props;
    const path = (arr, i) => {
        let p = "/app"
        for (let idx = 0; idx <= i; idx++) {
            const e = elements[idx];
            p+=`/${arr[idx]?.uuid}`
        }
        return p
    }
    return (
        <div className='bg bg-fwhite' style={{ margin: "3px", padding: "3px 9px", fontSize: "13px", fontWeight: "300", display: "flex", justifyContent: "start", alignItems: "center", gap: "7px" }}>
            <nav>
                <ol className="breadcrumb" style={{ marginBottom: "0" }}>
                    {JSXMap(elements, (e, idx) => {
                        if (!elements || elements.length < idx || !e || e.hidden) return;
                        if (idx + 1 == elements.length) return (<li key={idx} className="breadcrumb-item active">
                            <div style={{ display: "inline-flex", gap: "7px" }}>
                                <div style={{ flex: "0 0 12px" }}><i className="fa fa-circle" style={{ color: (e?.color)?e?.color:"transparent" }}></i></div>
                                <div style={{ flex: "1 1 auto", textAlign: "left", textWrap: "nowrap" }}>{e?.name}</div>
                            </div>
                        </li>);
                        return (<li key={idx} className="breadcrumb-item">
                            <a href={path(elements,idx)}>
                                <div style={{ display: "inline-flex", gap: "7px" }}>
                                    <div style={{ flex: "0 0 12px" }}><i className="fa fa-circle" style={{ color: (e?.color)?e?.color:"transparent" }}></i></div>
                                    <div style={{ flex: "1 1 auto", textAlign: "left", textWrap: "nowrap" }}>{e?.name}</div>
                                </div>
                            </a>
                        </li>
                        )
                    })}

                    {/* <li className="breadcrumb-item active">Library</li> */}
                </ol>
            </nav>
        </div>)
}